import fs from "fs";

const _getCacheFile = (key:string) => {
  key = key.replaceAll("/", "-").replaceAll("?", "-").replaceAll("&", "-").replaceAll("=", "-");
  key = decodeURIComponent(key);
  if(key.length > 250) key =  key.substring(0,250);

  return process.env.CACHE_PATH + "/" + key;
};

const ensureCacheDir = async () => {
  await fs.promises.mkdir(process.env.CACHE_PATH, { recursive: true });
};

class FileCache {
  private readonly _cache: any;

  constructor() {
    this._cache = {
      get: async (key) => {
        await ensureCacheDir();
        return fs.promises
          .readFile(_getCacheFile(key), "utf-8")
          .catch((e) => null);
      },
      set: async (key, textData) => {
        await ensureCacheDir();
        return fs.promises.writeFile(_getCacheFile(key), textData, "utf-8");
      },
      remove: async (key) => {
        await ensureCacheDir();
        return fs.promises.rm(_getCacheFile(key));
      },
    };
  }

  async clear() {
    this._cache.clear().then(() => console.log("Cache Cleared"));
  }

  async getAll() {
    return this._cache;
  }

  async get(key, fullResponse = false) {
    let response = await this._cache.get(key).catch((err) => {
      return null;
    });
    if (!response) return null;
    let output = JSON.parse(response);
    return fullResponse ? output : output.data;
  }

  async set(key, data, cacheTimeInSeconds) {
    console.log("cache SET key:", key);
    const expiresAtInMS = cacheTimeInSeconds * 1000 + Date.now();
    return this._cache.set(key, JSON.stringify({ data, expiresAtInMS }));
  }

  async hasKey(key) {
    const cacheData = (await this.get(key, true)) || {};
    const { expiresAtInMS, data = null } = cacheData;
    if (data && parseInt(expiresAtInMS) > Date.now()) {
      //console.log("cache file  EXISTS key:", key);
      return true;
    } else if (data) {
      console.log("cache file DELETE key:", key);
      await this._cache.remove(key).then(() => null);
    }
    return false;
  }
}

export default FileCache;
